// No-op stub for `streamdown` (transitive via @copilotkit/react-core v2). The app
// renders copilot messages with @memorang/ui MarkdownRenderer, never CopilotKit's
// chat UI, so streamdown is dead code that bundled Shiki+Mermaid+KaTeX (300+ chunks,
// ~doubling web build time).
const Streamdown = ({ children }) => children ?? null;

module.exports = {
	Streamdown,
	Block: Streamdown,
	StreamdownContext: null,
	defaultRehypePlugins: [],
	defaultRemarkPlugins: [],
	parseMarkdownIntoBlocks: (markdown) => (markdown ? [markdown] : []),
	default: Streamdown,
};
